const newsRouter = {
    route: null,
    name: null,
    title: '资讯管理',
    type: 'folder', // 类型: folder, tab, view
    icon: 'iconfont icon-tushuguanli',
    filePath: 'view/news/', // 文件路径
    order: null,
    inNav: true,
    children: [
      {
        title: '资讯列表',
        type: 'view',
        name: 'NewsList',
        route: '/news/list',
        filePath: 'view/news/articles/article-list.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
      },
      {
        title: '资讯分类',
        type: 'view',
        name: 'CategoryList',
        route: '/news/category/list',
        filePath: 'view/news/category/category-list.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
      }      
    ],
  }
  
  export default newsRouter
  